"use client";

import dynamic from "next/dynamic";
import { useSyncExternalStore } from "react";
import type { LookScheme } from "@/types/look-system";
import {
  mapTilesRegion,
  type CaseMapDeluxeView,
} from "@/utils/case-map-deluxe";

const CaseMapDeluxeMap = dynamic(() => import("./CaseMapDeluxeMap.client"), {
  ssr: false,
});

const subscribe = (notify: () => void) => {
  const observer = new MutationObserver(notify);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-re-scheme"],
  });
  return () => observer.disconnect();
};
const currentScheme = (): LookScheme =>
  document.documentElement.dataset.reScheme === "dark" ? "dark" : "light";
const serverScheme = (): LookScheme => "light";

/** Sagskort Deluxe's map, drawn only in the browser, in the colours of the scheme the page shows. */
export default function CaseMapDeluxe({
  latitude,
  longitude,
  view,
}: {
  latitude: number;
  longitude: number;
  view: CaseMapDeluxeView;
}) {
  const scheme = useSyncExternalStore(subscribe, currentScheme, serverScheme);
  return (
    <CaseMapDeluxeMap
      latitude={latitude}
      longitude={longitude}
      region={mapTilesRegion(latitude, longitude)}
      zoom={view.zoom}
      zoomControls={view.zoomControls}
      showLabels={view.showLabels}
      intro={view.intro}
      scheme={view[scheme]}
    />
  );
}
